<template>
  <div class="container">
    <h1 class="title is-1">
      Page not found
    </h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound',

  metaInfo: {
    title: 'Not Found'
  }
}
</script>

<style>

</style>
